<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <template v-if="type == 1">
            <a-col :span="12">
              <a-form-item :label="$t('表编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['meterId']" :placeholder="$t('请输入表编号')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('表安装地址')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userMeterAddr']" :placeholder="$t('请输入水表安装地址')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('表起始读数')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userMeterStartNum']" :placeholder="$t('请输入用户表起始读数')" suffix="m³" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('所属区域')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userAreaId']" :placeholder="$t('请输入用户区域Id')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('所属区域名称')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userAreaName']" :placeholder="$t('请输入用户所在区域名称')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户所在小区名或村庄名')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userCommName']" :placeholder="$t('请输入用户所在小区名或村庄名')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('安装纬度')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userMeterLat']" :placeholder="$t('请输入水表安装纬度')" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('安装经度')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userMeterLng']" :placeholder="$t('请输入水表安装经度')" style="width: 100%"/>
              </a-form-item>
            </a-col>
          </template>
          <template v-else-if="type == 2">
            <a-col :span="12">
              <a-form-item :label="$t('用户编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userId']" :placeholder="$t('请输入用户编号')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户户型信息Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userHouseholdCode']" :placeholder="$t('请输入用户户型信息Id')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户类型编码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userTypeCode']" :placeholder="$t('请输入用户类型编码')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户手机号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userPhone']" :placeholder="$t('请输入用户手机号')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户价格编码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userPriceCode']" :placeholder="$t('请输入用户价格编码')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户地址')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userAddr']" :placeholder="$t('请输入用户地址')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户开户时阀门开关状态 0无动作 1 开阀 2 关阀')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userValveOpenorclose']" :placeholder="$t('请输入用户开户时阀门开关状态 0无动作 1 开阀 2 关阀')" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户开户时表读数')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userMeterOpenNum']" :placeholder="$t('请输入用户开户时表读数')" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户唯一地址标识')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userAddrId']" :placeholder="$t('请输入用户唯一地址标识')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户营收编号 一般和用户编号一致')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userPayId']" :placeholder="$t('请输入用户营收编号 一般和用户编号一致')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('身份证号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userIdNumber']" :placeholder="$t('请输入身份证号')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用来标识是自然人 还是 企业')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userIdType']" :placeholder="$t('请输入用来标识是自然人 还是 企业')" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户区域Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userAreaId']" :placeholder="$t('请输入用户区域Id')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户所在区域名称')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userAreaName']" :placeholder="$t('请输入用户所在区域名称')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户所在小区名或村庄名')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userCommName']" :placeholder="$t('请输入用户所在小区名或村庄名')"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户用水状态 0未开始计费 1已开始计费')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userState']" :placeholder="$t('请输入用户用水状态 0未开始计费 1已开始计费')" style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item :label="$t('用户是否允许缴费 0不允许 1允许')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['userPayState']" :placeholder="$t('请输入用户是否允许缴费 0不允许 1允许')" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('用户优惠信息')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['userFreeinfo']" :placeholder="$t('请输入用户优惠信息')"></a-input>
              </a-form-item>
            </a-col>
          </template>

          <a-col :span="24">
            <a-form-item label="remark" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['remark']" rows="4" :placeholder="$t('请输入remark')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{ $t('提 交') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'MeterUserinfoForm',
    components: {
      JFormContainer,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        type: 1,// 默认是添加表信息的model
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      add (type) {
        console.log("type"+type)
        this.type = type;
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'meterId','userId','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          } 
        })
      },
      // popupCallback(row){
      //   this.form.setFieldsValue(pick(row,'meterId','userId','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
      // },
    }
  }
</script>